import { render, staticRenderFns } from "./preArchiveSeries.vue?vue&type=template&id=1450f5d5&scoped=true&"
import script from "./preArchiveSeries.vue?vue&type=script&lang=js&"
export * from "./preArchiveSeries.vue?vue&type=script&lang=js&"
import style0 from "./preArchiveSeries.vue?vue&type=style&index=0&id=1450f5d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1450f5d5",
  null
  
)

export default component.exports